export const POSITION_STATUS = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
};